import { Crown } from "@phosphor-icons/react";

export default function CurrentPlan({ plan, current }) {
  if (!plan) return null;
  return (
    <div
      className="zx-card flex items-center justify-between gap-4 p-5"
      data-testid="current-plan"
    >
      <div className="flex items-center gap-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[rgba(139,30,63,0.18)] ring-1 ring-[rgba(184,50,90,0.45)]">
          <Crown size={18} weight="thin" color="#e9b5c5" />
        </div>
        <div>
          <p className="zx-label">Tu plan</p>
          <h2 className="font-serif text-2xl tracking-tight">{plan.name}</h2>
        </div>
      </div>
      <div className="text-right">
        <p className="text-[10px] uppercase tracking-[0.22em] text-[rgba(255,255,255,0.55)]">
          Estado
        </p>
        <p className="font-serif text-xl text-[#a9e3b3]">
          {current.status === "active" ? "Activo" : current.status}
        </p>
        {current.renewsAt && (
          <p className="text-[10px] uppercase tracking-[0.22em] text-[rgba(255,255,255,0.4)]">
            Renovación {new Date(current.renewsAt).toLocaleDateString("es-ES")}
          </p>
        )}
      </div>
    </div>
  );
}
